import { styled } from '@linaria/react';
import Check from './svg/check.svg?react';

export const StyledCheck = styled(Check)`
    width: 17px;
    height: 18px;
`;
